// extracted by mini-css-extract-plugin
export var actionCancel = "GeolocationRedirectModal-module--actionCancel--bdb7e";
export var childContent = "GeolocationRedirectModal-module--childContent--244a0";
export var closeLink = "GeolocationRedirectModal-module--closeLink--1b642";
export var content = "GeolocationRedirectModal-module--content--07e5e";
export var heading = "GeolocationRedirectModal-module--heading--90a9e";
export var message = "GeolocationRedirectModal-module--message--de2eb";
export var modal = "GeolocationRedirectModal-module--modal--41350";